import { NavSubLevelModal } from "@NA/Services/ADIShopMyBranchService";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { IconProps } from "@insite/mobius/Icon";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Link, { StyledIcon } from "@insite/mobius/Link";
import ListItem, { UnorderedList } from "@insite/mobius/Lists";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    title?: string;
    leftNavData?: NavSubLevelModal[];
    showMoreButton?: boolean;
}

type Props = OwnProps;

const ADIShopMyBranchLeftNav = ({ title, leftNavData, showMoreButton }: Props) => {
    interface ShopMyBranchDCLeftNavStyles {
        listStyle?: InjectableCss;
        innerUnorderedListStyle?: InjectableCss;
        innerListItemStyle?: InjectableCss;
        moreBrandsLinkStyle?: InjectableCss;
        menuItemIcon?: IconProps;
    }

    const shopMyBranchDCLeftNavStyles: ShopMyBranchDCLeftNavStyles = {
        listStyle: {
            css: css`
                > ul {
                    list-style: none !important;
                    padding: 0 !important;
                    margin: 0 !important;
                    max-height: 393px;
                    width: 100% !important;
                    padding-right: 22px !important;
                    overflow: auto !important;
                    &::-webkit-scrollbar {
                        width: 5px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: ${ADIColors.gray7};
                        border-radius: 10px;
                    }
                }
                .parent-menu {
                    display: flex;
                    justify-content: space-between;
                }
            `,
        },
        innerUnorderedListStyle: {
            css: css`
                max-height: 393px;
                width: 100% !important;
                padding-right: 22px !important;
                overflow: auto !important;
                &::-webkit-scrollbar {
                    width: 5px;
                }
                &::-webkit-scrollbar-thumb {
                    background: ${ADIColors.gray7};
                    border-radius: 10px;
                }
            `,
        },
        innerListItemStyle: {
            css: css`
                margin-bottom: 12px;
                > a {
                    font-size: 14px;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    &:hover {
                        text-decoration: underline;
                    }
                    > span {
                        color: ${ADIColors.black} !important;
                    }
                }
            `,
        },
        moreBrandsLinkStyle: {
            css: css`
                margin-bottom: 12px;
                font-weight: bold !important;
                color: ${ADIColors.blue5} !important;
                > a {
                    &:hover {
                        text-decoration: underline;
                    }
                }
            `,
        },
        menuItemIcon: {
            css: css`
                margin: 0 0 0 10px;
            `,
            size: 18,
            color: `${ADIColors.black}`,
        },
    };

    const [expandNav, setExpanNav] = useState<boolean>(true);

    const showListOptionStyle = {
        css: css`
            display: ${expandNav ? "block" : "none"};
        `,
    };

    const downIcon = <StyledIcon src={ChevronDown} {...shopMyBranchDCLeftNavStyles.menuItemIcon} />;
    const upIcon = <StyledIcon src={ChevronUp} {...shopMyBranchDCLeftNavStyles.menuItemIcon} />;

    return (
        <ListItem {...shopMyBranchDCLeftNavStyles.listStyle}>
            <StyledWrapper onClick={() => setExpanNav(!expandNav)} className="parent-menu">
                <StyledWrapper>{translate(`${title}`)}</StyledWrapper>
                {expandNav ? upIcon : downIcon}
            </StyledWrapper>
            <UnorderedList {...shopMyBranchDCLeftNavStyles.innerUnorderedListStyle} {...showListOptionStyle}>
                {leftNavData?.map((eachOption: NavSubLevelModal) => (
                    <>
                        <ListItem {...shopMyBranchDCLeftNavStyles.innerListItemStyle} key={eachOption.name}>
                            <Link href={eachOption.path}>{eachOption.name}</Link>
                        </ListItem>
                    </>
                ))}
                {title === "Brands" && showMoreButton && leftNavData?.length! > 0 && (
                    <ListItem
                        {...shopMyBranchDCLeftNavStyles.innerListItemStyle}
                        {...shopMyBranchDCLeftNavStyles.moreBrandsLinkStyle}
                    >
                        <Link href="/Catalog/shop-brands">More</Link>
                    </ListItem>
                )}
            </UnorderedList>
        </ListItem>
    );
};

export default ADIShopMyBranchLeftNav;
